import {useMemo} from "react";
import {useTranslation} from "react-i18next";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";
import {useForm} from "react-hook-form";

export const useParentDetailsForm = (data) => {
    const {t} = useTranslation();

    const defaultValues = useMemo(() => ({
        title: data?.title || "",
        forename: data?.forename || "",
        surname: data?.surname || "",
        suffix: data?.suffix || "",
        emailAddress: data?.emailAddress || "",
        confirmEmailAddress: data?.confirmEmailAddress || "",
        phoneNumberCountryCode: data?.phoneNumberCountryCode || "",
        phoneNumber: data?.phoneNumber || "",
        onBehalfOfAnOrganisation: data?.onBehalfOfAnOrganisation || false,
        optedIntoMarketing: data?.optedIntoMarketing || false,
    }), [data]);

    const schema = useMemo(() => yup.object().shape({
        title: yup.string().required(t("validation.required")),
        forename: yup.string().required(t("validation.required")),
        surname: yup.string().required(t("validation.required")),
        suffix: yup.string(),
        emailAddress: yup
            .string()
            .email(t("validation.emailInvalid"))
            .required(t("validation.required")),
        confirmEmailAddress: yup
            .string()
            .oneOf([yup.ref("emailAddress")], t("validation.emailMismatch"))
            .required(t("validation.required")),
        phoneNumberCountryCode: yup.string().required(t("validation.required")),
        phoneNumber: yup.string().required(t("validation.required")),
        onBehalfOfAnOrganisation: yup.boolean(),
        optedIntoMarketing: yup.boolean(),
    }));

    const {
        control,
        handleSubmit,
        formState: {errors, isValid, isDirty},
        watch,
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues,
    });

    return {
        handleSubmit,
        control,
        errors,
        isValid,
        watch,
        isDirty,
    };
};
